ACC.multiselect = {
  initMultiSelect: function($multiSelect) {
    $multiSelect.each(function() {
      var selectObj = {
        $select: $(this),
        selectParent: $(this).parent(),
        selectLink: $(this).parent().find('a.selectBox'),
        $moreTextDiv: $('.ph-multiselect__more'),
        moreText: '',
        selectBoxSelected: 'selectBox-selected',
        selectHidden: 'ph-option_hide',
        selectedValue: $(this).val(),
        newselectoptions: 'ph-newselect_options'
      };

      if (selectObj.selectParent.find('.ph-newselect_options').length === 0) {
        selectObj.selectOptions = selectObj.selectLink.find('.selectBox-options');
        selectObj.selectoptionClone = selectObj.selectOptions.clone();
        selectObj.selectLink.addClass('ph-selectBox');
        selectObj.selectParent.addClass('ph-multiselect_wrapper');
        selectObj.selectOptions.remove();
        selectObj.selectoptionClone.addClass('ph-newselect_options');
        selectObj.selectParent.append(selectObj.selectoptionClone);
        selectObj.newOption = selectObj.selectParent.find('.ph-newselect_options');
        ACC.multiselect.setMultiSelectInitValues(selectObj);
        selectObj.newOption.find('.selectBox-disabled').hide();

        if (selectObj.$moreTextDiv.length > 1) {
          selectObj.moreText = selectObj.$moreTextDiv[0].innerText;
        } else if (selectObj.$moreTextDiv.length === 1) {
          selectObj.moreText = selectObj.$moreTextDiv.text();
        }

        selectObj.selectLink.on('click', function() {
          if (selectObj.selectParent.find('.ph-newselect_options:visible').length === 0) {
            selectObj.selectParent.parent().find('.' + selectObj.newselectoptions).hide();
            selectObj.newOption.show();
          } else {
            selectObj.selectParent.parent().find('.' + selectObj.newselectoptions).hide();
          }
        });
        $(document).on('click', function(event) {
          if ($(event.target).closest('.ph-multiselect_wrapper').length === 0) {
            selectObj.newOption.hide();
          }
        });

        selectObj.newOption.on('click', 'li:not(.selectBox-disabled) a', function() {
          var clickObj = {
            $clickItem: $(this)
          };

          clickObj.clickParent = clickObj.$clickItem.parent();
          clickObj.value = clickObj.$clickItem.attr('rel');
          selectObj.selectedValue.push(clickObj.value);
          ACC.multiselect.setMultiSelectInitValues(selectObj);
          selectObj.$select.val(selectObj.selectedValue);
        });
      } else {
        ACC.multiselect.setMultiSelectInitValues(selectObj);
        selectObj.selectParent.find('li.ph-option_hide').removeClass(selectObj.selectHidden);
      }
    });
  },
  setMultiSelectInitValues: function(selectObj) {
    var defaultText = selectObj.selectParent.find('select option[disabled]').text(),
        moreValues = false,
        selectedLabels = '',
        showMoreList = '',
        moreOptions = 'ph-more_options';

    selectObj.selectLink.html('<span class="selectBox-label ph-multiselect-label">&nbsp;</span><span class="selectBox-arrow ph-multiselect-arrow"></span>');
    selectObj.labelHolder = selectObj.selectLink.find('.ph-multiselect-label');

    if (selectObj.selectedValue.length > 0) {
      $.each(selectObj.selectedValue, function(k, v) {
        var itemText = selectObj.selectParent.find('select option[value="' + v + '"]').text();

        if (k < 2) {
          selectedLabels = selectedLabels + '<span class="ph-multiselect_value" rel="' + v + '" title="' + itemText + '">';
          selectedLabels = selectedLabels + itemText + '<i class="ph-select_remove"></i></span>';
        } else {
          if (!moreValues) {
            moreValues = true;
            selectedLabels = selectedLabels + '<span class="ph-multiselect_value ph-more">+' + (selectObj.selectedValue.length - 2) + ' ';
            selectedLabels = selectedLabels + selectObj.moreText + '<ul class="' + moreOptions + '">';
          }

          showMoreList = showMoreList + '<li class="ph-multiselect_list_more" rel="' + v + '" title="' + itemText + '">';
          showMoreList = showMoreList + itemText + '<i class="ph-select_remove"></i></li>';
        }

        selectObj.newOption.find('[rel="' + v + '"]').closest('li').addClass(selectObj.selectHidden);
      });

      if (moreValues) {
        selectedLabels = selectedLabels + showMoreList + '</ul></span>';
      }

      selectObj.labelHolder.html(selectedLabels);
    } else {
      selectObj.labelHolder.text(defaultText);
    }

    selectObj.labelHolder.on('click', '.ph-select_remove', function() {
      var removeValue = $(this).parent().attr('rel'),
          listItem = selectObj.newOption.find('li [rel="' + removeValue + '"]'),
          listItemParent = listItem.parent();

      listItemParent.removeClass(selectObj.selectHidden);
      $(this).closest('.ph-multiselect_value').remove();
      selectObj.selectedValue.splice($.inArray(removeValue, selectObj.selectedValue), 1);
      ACC.multiselect.setMultiSelectInitValues(selectObj);
      selectObj.$select.val(selectObj.selectedValue);
    });
  }
};

$(window).on('load', function() {
  var $multiSelect = $('select[multiple]');

  if ($multiSelect.length > 0) {
    ACC.multiselect.initMultiSelect($multiSelect);
  }
});
